import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, isRef as _isRef, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-4a7586e5")
const _hoisted_1 = { class: "button" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("mdi-content-copy")
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = { class: "ml-4 text-error text-caption" }
const _hoisted_5 = {
  disabled: "",
  selected: "",
  value: ""
}
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "ml-4 text-error text-caption" }
_popScopeId()

import { withDefaults, ref, onMounted, PropType } from 'vue'
import Action from '../../Dialog/enums/DialogAction'
import TheDialog from '../../Dialog/TheDialog.vue'
import { required } from '@/lib/validation'
import { Field, useField } from 'vee-validate'
import { AxiosInstance } from 'axios'
import createHoppermationAPIClient from '@/clients/hoppermation'
import { IAutomation, IChannel } from '@/interfaces/hoppermation'
import bus from '@/lib/eventBus'
import EventNames from '@/lib/enums/eventNames'

interface IProps {
  channels: PropType<IChannel[]>
  automation?: IAutomation
  submit?: () => void
}


export default /*#__PURE__*/_defineComponent({
  props: {
    channels: { type: null, required: true, default: () => [] },
    automation: { type: null, required: false, default: () => ({} as IAutomation) },
    submit: { type: Function, required: false, default: () => ({}) }
  },
  setup(__props: any) {

const props = __props as { channels: PropType<IChannel[]>, automation: IAutomation, submit: () => void }


const hoppermationApiClient = ref({} as AxiosInstance)
const serverError = ref('')
const channel = ref(props.automation.channelId)
const action = Action.CONFIRM
const rules = { required }
const {
  validate,
  errorMessage,
  value: automationName
} = useField('automationName', required, {
  initialValue: props.automation.name
})

onMounted(async () => {
  hoppermationApiClient.value = await createHoppermationAPIClient()
})

const duplicate = async (): Promise<boolean> => {
  const { valid } = await validate()
  if (valid) {
    const data = {
      channelId: channel.value,
      name: automationName.value
    }

    try {
      await hoppermationApiClient.value.post(`/automations/${props.automation.id}/duplicate`, data)
      bus.$emit(EventNames.SHOW_SNACKBAR, { color: 'success', text: 'snackbar.automation.duplicate.success' })
      props.submit()
      return true
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      serverError.value = error.response.data.message[0]
      bus.$emit(EventNames.SHOW_SNACKBAR, { color: 'error', text: 'snackbar.automation.duplicate.error' })
      return false
    }
  }
  return false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createBlock(TheDialog, {
    action: _unref(action),
    title: _ctx.$t('dialog.duplicate.title'),
    imageSrc: "https://assets8.lottiefiles.com/packages/lf20_u25cckyh.json",
    submit: duplicate,
    errors: serverError.value
  }, {
    activator: _withCtx(({ props }) => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_v_icon, _mergeProps(props, {
          size: "small",
          class: "mr-5"
        }), {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 2
        }, 1040)
      ])
    ]),
    content: _withCtx(() => [
      _createElementVNode("p", {
        class: "mb-4 text-subtitle",
        innerHTML: _ctx.$t('dialog.duplicate.desc', { automationName: props.automation.name })
      }, null, 8, _hoisted_3),
      _createVNode(_component_v_form, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            class: _normalizeClass(["row-max", _unref(errorMessage) ? 'mb-3' : ''])
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "pa-0" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    name: "automationName",
                    modelValue: _unref(automationName),
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(automationName) ? automationName.value = $event : null)),
                    "persistent-hint": "",
                    label: _ctx.$t('dialog.edit.automation.label'),
                    hint: _ctx.$t('dialog.edit.automation.hint'),
                    class: "mb-0"
                  }, null, 8, ["modelValue", "label", "hint"]),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(errorMessage) ? _ctx.$t(_unref(errorMessage)) : ''), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["class"]),
          _createVNode(_component_v_row, { class: "row-max" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "px-0" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Field), {
                    name: "channel",
                    rules: rules.required,
                    modelValue: channel.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (channel.value = $event))
                  }, {
                    default: _withCtx(({ field, errorMessage }) => [
                      _createElementVNode("select", _mergeProps(field, { class: "px-4 width-full select" }), [
                        _createElementVNode("option", _hoisted_5, _toDisplayString(_ctx.$t('dialog.create.channel.unselected')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.channels, (item) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: item.id,
                            value: item.id
                          }, _toDisplayString(item.name), 9, _hoisted_6))
                        }), 128))
                      ], 16),
                      _createElementVNode("span", _hoisted_7, _toDisplayString(errorMessage ? _ctx.$t(errorMessage) : ''), 1)
                    ]),
                    _: 1
                  }, 8, ["rules", "modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["action", "title", "errors"]))
}
}

})